import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { of, Subject, switchMap } from 'rxjs';
import { FilterOperators } from 'src/app/common/enums';
import { DictionaryService } from 'src/app/data/dictionary.service';
import { OrderService } from 'src/app/data/order.service';
import { UserService } from 'src/app/data/user.service';
import { FilterType } from 'src/app/list-filter/enums/filter-type.enum';
import { FilterService } from 'src/app/list-filter/services/filter.service';
import { FilterTypeEnum } from 'src/app/models/enums/filter-type-enum';

@Injectable()
export class OrdersStartRealizationListFilterService extends FilterService {
  protected userService: UserService;
  private translateService = inject(TranslateService);
  private dictionaryService = inject(DictionaryService);
  private orderService = inject(OrderService);

  protected filterType = FilterTypeEnum.OrdersStartRealizationList;
  private subject: Subject<string> = new Subject<string>();


  constructor() {
    const userService = inject(UserService);

    super(FilterTypeEnum.OrdersStartRealizationList, userService);
    this.userService = userService;


    this.config = [
      {
        id: 1,
        name: 'positionExpectationId',
        label: this.translateService.instant('Order.StartRealizationList.PositionExpectation'),
        property: 'PositionExpectationId',
        operator: FilterOperators.Equal,
        default: true,
        multiple: true,
        type: FilterType.Select,
        datasource$: this.orderService.getPositionExpectations(),
        searchTextChangeCallback: (value: any) => this.subject.next(value),
      },
      {
        id: 2,
        name: 'employerId',
        label: this.translateService.instant('Order.StartRealizationList.Employer'),
        property: 'EmployerId',
        operator: FilterOperators.Equal,
        default: true,
        multiple: true,
        type: FilterType.Autocomplete,
        datasource$: this.subject.asObservable().pipe(switchMap((value: string) => (value ? this.dictionaryService.getEmployers(value) : of([])))),
        searchTextChangeCallback: (value: any) => this.subject.next(value),
      },
      {
        id: 3,
        name: 'employerObjectId',
        label: this.translateService.instant('Order.StartRealizationList.EmployerObject'),
        property: 'EmployerObjectId',
        operator: FilterOperators.Equal,
        default: true,
        multiple: true,
        type: FilterType.Autocomplete,
        datasource$: this.subject.asObservable().pipe(switchMap((value: string) => (value ? this.orderService.getAvailableEmployerObjects(value) : of([])))),
        searchTextChangeCallback: (value: any) => this.subject.next(value),
      },
      {
        id: 4,
        name: 'isRealizationDate',
        label: this.translateService.instant('Order.StartRealizationList.IsRealizationDate'),
        property: 'IsRealizationDate',
        default: true,
        multiple: true,
        datasource$: this.booleanFilter(),
        operator: FilterOperators.Equal,
        type: FilterType.Select
      },
      {
        id: 5,
        name: this.dateRangeFields("workerRealizationDate"),
        label: this.translateService.instant('Order.StartRealizationList.WorkerRealizationDate'),
        property: 'WorkerRealizationDate',
        default: true,
        type: FilterType.DateRange
      },
      {
        id: 6,
        name: this.dateRangeFields("startDate"),
        label: this.translateService.instant('Order.StartRealizationList.StartDate'),
        property: 'StartDate',
        default: true,
        type: FilterType.DateRange
      },
    ];
  }
}
